<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
      :rules="rules"
      :model="formLabelAlign"
    >
      <el-form-item label="授权信息名称">
        <el-input v-model.trim="formLabelAlign.name" class="inpser" />
      </el-form-item>
      <el-form-item v-if="formLabelAlign.type === 1" label="视频号名称">
        <el-input v-model.trim="formLabelAlign.channel_name" class="inpser" />
        <!-- <el-button type="primary" @click="sumbit">选择</el-button> -->
      </el-form-item>
      <el-form-item v-else-if="formLabelAlign.type !== 101" label="app_id">
        <el-input v-model.trim="formLabelAlign.app_id" class="inpser" />
        <!-- <el-button type="primary" @click="sumbit">选择</el-button> -->
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="formLabelAlign.type" placeholder="请选择" @change="changeLeixing">
          <el-option
            v-for="item in accountType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="formLabelAlign.type === 1" label="授权范围">
        <el-radio-group v-model="formLabelAlign.auth_scope">
          <el-radio :label="'ALL'">视频号授权</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="formLabelAlign.type === 1" label="合作关系">
        <el-radio-group v-model="formLabelAlign.relationship">
          <el-radio :label="'RELATIONSHIP_EMPLOYMENT'">合作视频号</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-else-if="formLabelAlign.type !== 101" label="股权截图">
        <el-image
          v-if="url"
          style="width: 100px; height: 100px"
          :src="url"
          :preview-src-list="[url]"
          @click.stop="handleClickStop"
        />
        <el-button type="primary" @click="select">选择</el-button>
      </el-form-item>

      <el-form-item v-if="formLabelAlign.type!==101" label="授权过期时间">
        <el-radio-group v-model="formLabelAlign.auth_ttl_day">
          <el-radio :label="3">3天</el-radio>
          <el-radio :label="7">7天</el-radio>
          <el-radio :label="30">30天</el-radio>
          <el-radio :label="36145">不限</el-radio>
          <el-radio label="z">自定义</el-radio>
        </el-radio-group>
        <el-input
          v-if="formLabelAlign.auth_ttl_day == 'z'"
          v-model.trim="auth_ttl_dayz"
          class="inpser"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="股权截图关联的素材中心图片"
      :visible.sync="dialogVisibleafuwe"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <ChooseImg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
  </div>
</template>

<script>
import ChooseImg from '@/views/sourceMaterial/components/imgComp.vue'
import {
  adq_mkt_api_authManageadd,
  adq_mkt_api_authManageupdata
} from '@/api/customer.js'
export default {
  components: { ChooseImg },
  data() {
    return {
      labelPosition: 'right',
      dialogVisibleafuwe: false,
      formLabelAlign: {
        name: '',
        channel_name: '',
        app_id: '',
        stock_screenshot_id: '',
        auth_ttl_day: '',
        type: '',
        auth_scope: '',
        relationship: ''
      },
      accountType: [],
      url: '',
      rules: {
        name: [{ required: true, message: '请填写名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        auth_ttl_day: [
          { required: true, message: '请选择授权过期时间', trigger: 'blur' }
        ]
      },
      auth_ttl_dayz: '',
      id: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    select() {
      this.dialogVisibleafuwe = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1', 4)
      }, 100)
    },
    clickicon(img, key) {
      console.log(122226, img)
      console.log(img, '2222', key)
      const fileExtension = img.substring(img.lastIndexOf('.')).toLowerCase()
      if (
        ['.jpg', '.jpeg', '.png', '.gif'].includes(fileExtension.toLowerCase())
      ) {
        console.log(11121545)
        this.url = img
        this.formLabelAlign.stock_screenshot_id = key
        // 图像文件
      } else {
        this.$message({
          message: '不是图片格式',
          type: 'info'
        })
      }
      this.dialogVisibleafuwe = false
    },
    send(accountType, row) {
      console.log(accountType)
      this.accountType = accountType
      console.log('弹窗')
      if (row !== undefined) {
        const item = JSON.parse(JSON.stringify(row))
        this.id = item.id
        console.log('item:', item)
        this.formLabelAlign = {
          name: item.name,
          channel_name: item.channel_name,
          auth_scope: item.auth_scope,
          relationship: item.relationship,
          app_id: item.app_id,
          stock_screenshot_id: item.stock_screenshot_id,
          auth_ttl_day: item.auth_ttl_day,
          type: item.type
        }
        // eslint-disable-next-line eqeqeq
        if (
          Number(item.auth_ttl_day) !== 3 &&
          Number(item.auth_ttl_day) !== 7 &&
          Number(item.auth_ttl_day) !== 30 &&
          Number(item.auth_ttl_day) !== 36145
        ) {
          this.formLabelAlign.auth_ttl_day = 'z'
          this.auth_ttl_dayz = item.auth_ttl_day
        }
        this.url = item.stock_screenshot.path
      }
    },
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    sumbit() {
      if (this.formLabelAlign.name === '') {
        this.$message.error('请输入名称')
        return
      }
      if (this.formLabelAlign.type === '') {
        this.$message.error('请选择类型')
        return
      }
      if (this.formLabelAlign.type !== 101 && this.formLabelAlign.auth_ttl_day === '') {
        this.$message.error('请选择授权过期时间')
        return
      }
      if (
        this.formLabelAlign.auth_ttl_day === 'z' &&
        this.auth_ttl_dayz === ''
      ) {
        this.$message.error('请选择授权过期时间')
        return
      }
      if (this.id !== '') {
        adq_mkt_api_authManageupdata(this.id, this.formLabelAlign).then(
          (res) => {
            console.log('res', res)
            if (res.code === 0) {
              this.$message({
                message: '更新成功',
                type: 'success'
              })
              this.$emit('updata')
            }
          }
        )
      } else {
        adq_mkt_api_authManageadd(this.formLabelAlign).then((res) => {
          console.log('res', res)
          if (res.code === 0) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$emit('updata')
          }
        })
      }
    },
    changeLeixing(val) {
      console.log(this.formLabelAlign.type)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.inpser {
  width: 300px;
}
</style>
